import React from 'react';
import {
  DOT_MARKER_BORDER_WIDTH,
  DOT_MARKER_OUTER_SIZE,
  DOT_MARKER_SHADOW_OFFSET,
  DOT_MARKER_SHADOW_OPACITY,
  DOT_MARKER_SHADOW_RADIUS,
} from '@/experiences/sales-portal/components/map/constants';
import { DOT_MARKER_TRANSFORM } from '@/experiences/sales-portal/components/map/map-options.web';
import { MapMarkerData } from '@/experiences/sales-portal/components/map/types';
import { OverlayView } from '@react-google-maps/api';
import { useTheme } from '@/contexts/theme-context';
import { View } from '@usepepper/sprout-kit-ui';

interface MapDotMarkerProps {
  marker: MapMarkerData;
}

export const MapDotMarker: React.FC<MapDotMarkerProps> = ({ marker }) => {
  const theme = useTheme();

  return (
    <OverlayView
      mapPaneName={OverlayView.OVERLAY_LAYER}
      position={{
        lat: marker.coordinate.latitude,
        lng: marker.coordinate.longitude,
      }}
    >
      <View
        accessibilityLabel={marker.accessibilityLabel ?? ''}
        backgroundColor={theme.sk.color.icon.primary}
        borderColor={theme.sk.color.icon.ondark}
        borderRadius={DOT_MARKER_OUTER_SIZE / 2}
        borderWidth={DOT_MARKER_BORDER_WIDTH}
        height={DOT_MARKER_OUTER_SIZE}
        pointerEvents="none"
        shadowColor={theme.sk.color.bg.toast}
        shadowOffset={DOT_MARKER_SHADOW_OFFSET}
        shadowOpacity={DOT_MARKER_SHADOW_OPACITY}
        shadowRadius={DOT_MARKER_SHADOW_RADIUS}
        transform={DOT_MARKER_TRANSFORM}
        width={DOT_MARKER_OUTER_SIZE}
      />
    </OverlayView>
  );
};
